import { DataModel } from "common/models/utility-models/base-model"

export class StudentAvailabilityModel extends DataModel {
    isStudentAvailable:any=''
    semesterExamStart:any=''
    semesterExamEnds:any=''
    summerVacationStarts:any=''
    summerVacationEnds:any=''
    isExternalCompanyForInternship:any = ''
    internshipStartDate:any=''
    internshipEndDate:any=''
    studentAvailabilityRemark:any=''
    externalCompanyName: any = ''
    externalCompanyLocation: any = ''
    internshipCerty:any = ''
    isStudentJoined: any = ''
    reasonForNotJoined:any = ''
    isStudentContinued:any = ''
    reasonForNotContinued:any = ''
}
